module.exports = __webpack_public_path__ + "img/qrcode.0f2c30ee.gif";